import { AppConstants } from '../app.constants';

export class StringUtils {
	/**
	 * Capitaliza uma string.
	 *
	 * @param value - O valor a ser capitalizado.
	 * @returns A primeira letra maiúscula e as demais minusculas ou o próprio valor se for um valor falsy.
	 */
	static capitalize(value: string): string {
		if (!value) return value;

		if (value === AppConstants.actionType.hrPendency) {
			const word = value.split(' ');

			return `${word[0].charAt(0).toUpperCase()}${word[0].slice(1).toLowerCase()} ${word[1]}`;
		}

		return value[0].toUpperCase() + value.toLowerCase().slice(1);
	}

	/**
	 * Converte um valor para string, se não for já uma string.
	 *
	 * @param value - O valor a ser convertido.
	 * @returns O valor convertido em string ou `undefined` se o valor for `undefined`.
	 */
	static convertToString(
		value: object | string | undefined,
	): string | undefined {
		if (typeof value === 'object' && value !== null) {
			return JSON.stringify(value);
		}

		return value;
	}

	/**
	 * Obtém a primeira linha de uma string que contenha uma ou mais linhas, além de remover espaços vazios antes e depois
	 * deste texto selecionado
	 * @param text
	 * @returns
	 */
	static getFirstLine(text: string): string {
		return text.split('\n')[0].trim();
	}

	static getNullPlaceholder(): string {
		return '---';
	}

	/**
	 * Verifica se um valor é um UUID válido
	 * @param value
	 * @returns
	 */
	static isUuid(value: string): boolean {
		const UUID_REGEX =
			/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

		return UUID_REGEX.test(value);
	}
}
